// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ehit","footer":"styles_footer__3UU6I","passCodeTooltip":"styles_passCodeTooltip__3YYi6"};